// LOGIN
export const ACCOUNT_LOGIN_REQUEST = 'ACCOUNT_LOGIN_REQUEST';
export const ACCOUNT_LOGIN_SUCCESS = 'ACCOUNT_LOGIN_SUCCESS';
export const ACCOUNT_LOGIN_FAILURE = 'ACCOUNT_LOGIN_FAILURE';

// LOGOUT
export const ACCOUNT_LOGOUT = 'ACCOUNT_LOGOUT';
export const ACCOUNT_DETAILS_RESET = 'ACCOUNT_DETAILS_RESET';
export const ACCOUNT_LIST_RESET = 'ACCOUNT_LIST_RESET';

// REGISTER
export const ACCOUNT_REGISTER_REQUEST = 'ACCOUNT_REGISTER_REQUEST';
export const ACCOUNT_REGISTER_SUCCESS = 'ACCOUNT_REGISTER_SUCCESS';
export const ACCOUNT_REGISTER_FAILURE = 'ACCOUNT_REGISTER_FAILURE';

// GET DETAILS
export const ACCOUNT_DETAILS_REQUEST = 'ACCOUNT_DETAILS_REQUEST';
export const ACCOUNT_DETAILS_SUCCESS = 'ACCOUNT_DETAILS_SUCCESS';
export const ACCOUNT_DETAILS_FAILURE = 'ACCOUNT_DETAILS_FAILURE';

export const ACCOUNT_UPDATE_PROFILE_REQUEST = 'ACCOUNT_UPDATE_PROFILE_REQUEST'
export const ACCOUNT_UPDATE_PROFILE_SUCCESS = 'ACCOUNT_UPDATE_PROFILE_SUCCESS'
export const ACCOUNT_UPDATE_PROFILE_FAILURE = 'ACCOUNT_UPDATE_PROFILE_FAILURE'
export const ACCOUNT_UPDATE_PROFILE_RESET = 'ACCOUNT_UPDATE_PROFILE_RESET';

